import * as i0 from '@angular/core';
import { inject, Injectable, Component, Inject, NgModule } from '@angular/core';
import * as i3 from '@angular/forms';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@angular/material/dialog';
import * as i1$1 from '@angular/common/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as i2 from '@angular/router';
import { Router } from '@angular/router';
import { map, catchError, switchMap, tap, filter, take } from 'rxjs/operators';
import * as i4 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i5 from '@ngbracket/ngx-layout/flex';
import * as i6 from '@ngbracket/ngx-layout/extended';
import * as i7 from '@insight/ui';
import { NotificationComponent, AlertComponent, ConfirmComponent, ReasonComponent, DeleteComponent, SingleInputDialogComponent, UiModule } from '@insight/ui';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, ReplaySubject, Subject, of } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
const _c0 = a0 => ({
  "is-invalid": a0
});
function AuthenticateComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, " ");
  }
}
class IServiceConfiguration {
  environment;
}
let IApiService = /*#__PURE__*/(() => {
  class IApiService {
    http = inject(HttpClient);
    router = inject(Router);
    serviceConfiguration = inject(IServiceConfiguration);
    env = this.serviceConfiguration.environment;
    post(path, data = {}) {
      return this.http.post(`${this.env.apiUrl}${path}`, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json'
        }
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    get(path, params = new HttpParams()) {
      return this.http.get(`${this.env.apiUrl}${path}`, {
        params,
        headers: {
          'Content-Type': 'application/json'
        }
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    getBlob(path, params = new HttpParams()) {
      return this.http.get(`${this.env.apiUrl}${path}`, {
        params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json' // Optional, tergantung server
        }
      }).pipe(catchError(err => this.throwError(err)));
    }
    put(path, body = {}) {
      return this.http.put(`${this.env.apiUrl}${path}`, JSON.stringify(body), {
        headers: {
          'Content-Type': 'application/json'
        }
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    delete(path, body = {}) {
      return this.http.delete(`${this.env.apiUrl}${path}`, {
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    upload(path, file, update = false) {
      if (!update) {
        return this.http.post(`${this.env.apiUrl}${path}`, file).pipe(map(result => result.data), catchError(err => this.throwError(err)));
      }
      return this.http.put(`${this.env.apiUrl}${path}`, file).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    throwError(err) {
      if (err.status === 498) {
        // const returnUrl = this.activatedRoute.snapshot.queryParams.returnUrl || '';
        const returnUrl = this.router.url || '';
        return this.router.navigate(['/auth/logout'], {
          queryParams: {
            returnUrl
          }
        });
      } else {
        throw err;
      }
    }
    static ɵfac = function IApiService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IApiService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IApiService,
      factory: IApiService.ɵfac,
      providedIn: 'root'
    });
  }
  return IApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuthenticateService = /*#__PURE__*/(() => {
  class AuthenticateService {
    apiService;
    constructor(apiService) {
      this.apiService = apiService;
    }
    authenticate(credentials) {
      return this.apiService.post(`/auth/authenticate`, credentials);
    }
    static ɵfac = function AuthenticateService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AuthenticateService)(i0.ɵɵinject(IApiService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AuthenticateService,
      factory: AuthenticateService.ɵfac,
      providedIn: 'root'
    });
  }
  return AuthenticateService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuthenticateComponent = /*#__PURE__*/(() => {
  class AuthenticateComponent {
    dialogRef;
    authenticateService;
    formBuilder;
    formGroup;
    username;
    password;
    errorMessage = '';
    isSubmitting;
    formSubmitAttempt = false;
    constructor(dialogRef, authenticateService, formBuilder) {
      this.dialogRef = dialogRef;
      this.authenticateService = authenticateService;
      this.formBuilder = formBuilder;
    }
    ngOnInit() {
      this.initForm();
    }
    initForm() {
      this.username = new FormControl('', [Validators.required]);
      this.password = new FormControl('', [Validators.required]);
      this.formGroup = this.formBuilder.group({
        username: this.username,
        password: this.password
      });
    }
    submit() {
      this.isSubmitting = true;
      this.formSubmitAttempt = true;
      if (this.formGroup.invalid) {
        this.isSubmitting = false;
        return;
      }
      const credentials = this.formGroup.value;
      this.authenticateService.authenticate(credentials).subscribe(userId => {
        this.isSubmitting = false;
        this.dialogRef.close(userId);
      }, err => {
        this.isSubmitting = false;
        this.errorMessage = err.error.data;
      });
    }
    static ɵfac = function AuthenticateComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AuthenticateComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(AuthenticateService), i0.ɵɵdirectiveInject(i3.FormBuilder));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AuthenticateComponent,
      selectors: [["app-authenticate"]],
      decls: 30,
      vars: 9,
      consts: [["mat-dialog-title", ""], [1, "panel"], [1, "panel-body"], [1, "error-container"], [4, "ngIf"], ["novalidate", "", "fxLayout", "column", "fxLayoutGap", "10px", 1, "needs-validation", 3, "ngSubmit", "formGroup"], [1, "form-group"], [1, "small", "mb-0"], [1, "input-group"], ["id", "basic-addon1", 1, "input-group-text"], [1, "fas", "fa-user"], ["id", "userName", "formControlName", "username", "placeholder", "User Name", 1, "form-control", 3, "ngClass"], [1, "form-group", "mb-0"], [1, "fas", "fa-key"], ["id", "password", "formControlName", "password", "placeholder", "Password", "type", "password", 1, "form-control", 3, "ngClass"], ["type", "submit", 1, "btn", "btn-primary", "d-none"], ["fxLayout", "", "fxLayoutGap", "10px"], ["fxFlex", ""], ["className", "btn-primary", 3, "click", "isLoading"], [1, "fas", "fa-unlock", "me-2"], ["mat-dialog-close", "", 1, "btn", "btn-danger"], [1, "fa", "fa-times"], ["role", "alert", 1, "alert", "alert-danger"]],
      template: function AuthenticateComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h5", 0);
          i0.ɵɵtext(1, "Authentication");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 1)(3, "div", 2)(4, "div", 3);
          i0.ɵɵtemplate(5, AuthenticateComponent_ng_container_5_Template, 3, 1, "ng-container", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "form", 5);
          i0.ɵɵlistener("ngSubmit", function AuthenticateComponent_Template_form_ngSubmit_6_listener() {
            return ctx.submit();
          });
          i0.ɵɵelementStart(7, "div", 6)(8, "label", 7);
          i0.ɵɵtext(9, "User Name? ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "div", 8)(11, "span", 9);
          i0.ɵɵelement(12, "i", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(13, "input", 11);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(14, "div", 12)(15, "label", 7);
          i0.ɵɵtext(16, "Password ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(17, "div", 8)(18, "span", 9);
          i0.ɵɵelement(19, "i", 13);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(20, "input", 14);
          i0.ɵɵelementEnd()();
          i0.ɵɵelement(21, "button", 15);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(22, "mat-dialog-actions", 16);
          i0.ɵɵelement(23, "span", 17);
          i0.ɵɵelementStart(24, "loading-button", 18);
          i0.ɵɵlistener("click", function AuthenticateComponent_Template_loading_button_click_24_listener() {
            return ctx.submit();
          });
          i0.ɵɵelement(25, "i", 19);
          i0.ɵɵtext(26, " Authenticate ");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(27, "button", 20);
          i0.ɵɵelement(28, "i", 21);
          i0.ɵɵtext(29, " Cancel ");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ngIf", ctx.errorMessage);
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.formGroup);
          i0.ɵɵadvance(7);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0, ctx.username.invalid && ctx.formSubmitAttempt));
          i0.ɵɵadvance(7);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0, ctx.password.invalid && ctx.formSubmitAttempt));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("isLoading", ctx.isSubmitting);
        }
      },
      dependencies: [i4.NgClass, i4.NgIf, i5.DefaultLayoutDirective, i5.DefaultLayoutGapDirective, i5.DefaultFlexDirective, i6.DefaultClassDirective, i7.LoadingButtonComponent, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogActions, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.FormGroupDirective, i3.FormControlName],
      styles: [".panel-body[_ngcontent-%COMP%]{padding-top:10px;padding-bottom:20px}"]
    });
  }
  return AuthenticateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IAuthService = /*#__PURE__*/(() => {
  class IAuthService {
    http;
    router;
    serviceConfiguration;
    constructor(http, router, serviceConfiguration) {
      this.http = http;
      this.router = router;
      this.serviceConfiguration = serviceConfiguration;
    }
    getUserToken(authToken) {
      return this.http.post(`${this.serviceConfiguration.environment.authTokenUrl}`, '{}', {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    getRefreshedToken(refreshToken) {
      return this.http.post(`${this.serviceConfiguration.environment.authRefreshTokenUrl}`, '{}', {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': refreshToken
        }
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    getMenuToken(userToken) {
      return this.http.post(`${this.serviceConfiguration.environment.authMenuUrl}`, '{}', {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': userToken
        }
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    throwError(err) {
      if ([400, 401, 403, 498].includes(err.status)) {
        // const returnUrl = this.activatedRoute.snapshot.queryParams.returnUrl || '';
        const returnUrl = this.router.url || '';
        return this.router.navigate(['/auth/logout'], {
          queryParams: {
            returnUrl
          }
        });
      } else {
        throw err;
      }
    }
    static ɵfac = function IAuthService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IAuthService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2.Router), i0.ɵɵinject(IServiceConfiguration));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IAuthService,
      factory: IAuthService.ɵfac,
      providedIn: 'root'
    });
  }
  return IAuthService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IClipboardService = /*#__PURE__*/(() => {
  class IClipboardService {
    dom;
    // I initialize the Clipboard service.
    // --
    // CAUTION: This service is tightly couped to the browser DOM (Document Object Model).
    // But, by injecting the "document" reference rather than trying to reference it
    // globally, we can at least pretend that we are trying to lower the tight coupling.
    constructor(dom) {
      this.dom = dom;
    }
    // ---
    // PUBLIC METHODS.
    // ---
    // I copy the given value to the user's system clipboard. Returns a promise that
    // resolves to the given value on success or rejects with the raised Error.
    copy(value) {
      const promise = new Promise((resolve, reject) => {
        let textarea = null;
        try {
          // In order to execute the "Copy" command, we actually have to have
          // a "selection" in the currently rendered document. As such, we're
          // going to inject a Textarea element and .select() it in order to
          // force a selection.
          // --
          // NOTE: This Textarea is being rendered off-screen.
          textarea = this.dom.createElement('textarea');
          textarea.style.height = '0px';
          textarea.style.left = '-100px';
          textarea.style.opacity = '0';
          textarea.style.position = 'fixed';
          textarea.style.top = '-100px';
          textarea.style.width = '0px';
          this.dom.body.appendChild(textarea);
          // Set and select the value (creating an active Selection range).
          textarea.value = value;
          textarea.select();
          // Ask the browser to copy the current selection to the clipboard.
          this.dom.execCommand('copy');
          resolve(value);
        } finally {
          // Cleanup - remove the Textarea from the DOM if it was injected.
          if (textarea && textarea.parentNode) {
            textarea.parentNode.removeChild(textarea);
          }
        }
      });
      return promise;
    }
    static ɵfac = function IClipboardService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IClipboardService)(i0.ɵɵinject(DOCUMENT));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IClipboardService,
      factory: IClipboardService.ɵfac
    });
  }
  return IClipboardService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IColorService = /*#__PURE__*/(() => {
  class IColorService {
    constructor() {}
    get(index) {
      return colors[index];
    }
    static ɵfac = function IColorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IColorService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IColorService,
      factory: IColorService.ɵfac,
      providedIn: 'root'
    });
  }
  return IColorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const colors = ['rgba(255,99,132,0.6)', 'rgba(54,162,235,0.6)', 'rgba(255,206,86,0.6)', 'rgba(201,203,207,0.6)', 'rgba(70,200,70,0.6)', 'rgba(232,232,77,0.6)', 'rgba(255,69,109,0.6)', 'rgba(172,70,200,0.6)', 'rgba(235,150,65,0.6)', 'rgba(99,255,240,0.6)', 'rgba(252,136,196,0.6)'
// '#007bff',
// '#e83e8c',
// '#dc3545',
// '#fd7e14',
// '#ffc107',
// '#28a745',
// '#20c997',
// '#17a2b8',
// '#6c757d',
// '#343a40',
// '#007bff',
// '#6f42c1',
// '#6c757d',
// '#28a745',
// '#17a2b8',
// '#ffc107',
// '#dc3545',
// '#f8f9fa',
// '#6610f2',
// '#343a40',
// '#fb6b1d',
// '#e83b3b',
// '#831c5d',
// '#c32454',
// '#f04f78',
// '#f68181',
// '#fca790',
// '#e3c896',
// '#ab947a',
// '#966c6c',
// '#625565',
// '#3e3546',
// '#0b5e65',
// '#0b8a8f',
// '#1ebc73',
// '#91db69',
// '#fbff86',
// '#fbb954',
// '#cd683d',
// '#9e4539',
// '#7a3045',
// '#6b3e75',
// '#905ea9',
// '#a884f3',
// '#eaaded',
// '#8fd3ff',
// '#4d9be6',
// '#4d65b4',
// '#484a77',
// '#30e1b9',
// '#8ff8e2'
];
let IStorageService = /*#__PURE__*/(() => {
  class IStorageService {
    serviceConfiguration = inject(IServiceConfiguration);
    env = this.serviceConfiguration.environment;
    get storageName() {
      return this.env.apiKey;
    }
    get(key) {
      const session = JSON.parse(localStorage.getItem(this.storageName)) || {};
      return session[key];
    }
    getAll() {
      const session = JSON.parse(localStorage.getItem(this.storageName)) || {};
      return session;
    }
    set(key, value) {
      const session = JSON.parse(localStorage.getItem(this.storageName)) || {};
      session[key] = value;
      localStorage.setItem(this.storageName, JSON.stringify(session));
    }
    delete(key) {
      const session = JSON.parse(localStorage.getItem(this.storageName)) || {};
      session[key] = null;
      delete session[key];
      localStorage.setItem(this.storageName, JSON.stringify(session));
    }
    clear() {
      localStorage.removeItem(this.storageName);
    }
    static ɵfac = function IStorageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IStorageService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IStorageService,
      factory: IStorageService.ɵfac,
      providedIn: 'root'
    });
  }
  return IStorageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ISessionService = /*#__PURE__*/(() => {
  class ISessionService {
    dialog;
    storageService;
    authService;
    refreshTokenInProgress = false;
    refreshTokenSubject = new BehaviorSubject(null);
    constructor(dialog, storageService, authService) {
      this.dialog = dialog;
      this.storageService = storageService;
      this.authService = authService;
    }
    setTokens({
      userToken,
      refreshToken
    }) {
      this.storageService.set('ut', userToken);
      this.storageService.set('rt', refreshToken);
    }
    getUserToken() {
      return this.storageService.get('ut');
    }
    getRefreshToken() {
      return this.storageService.get('rt');
    }
    setMenuToken(menuToken) {
      this.storageService.set('mt', menuToken);
    }
    getMenuToken() {
      return this.storageService.get('mt');
    }
    refreshToken() {
      if (!this.refreshTokenInProgress) {
        this.refreshTokenInProgress = true;
        this.refreshTokenSubject.next(null);
        return this.authService.getRefreshedToken(this.getRefreshToken()).pipe(
        /* tap(({ userToken, refreshToken }) => {
          this.setTokens({ userToken, refreshToken });
          this.refreshTokenSubject.next({ userToken, refreshToken });
          this.refreshTokenInProgress = false;
        }) */
        switchMap(({
          userToken,
          refreshToken
        }) => {
          this.setTokens({
            userToken,
            refreshToken
          });
          this.refreshTokenSubject.next({
            userToken,
            refreshToken
          });
          this.refreshTokenInProgress = false;
          return this.authService.getMenuToken(userToken);
        }), tap(menuToken => {
          this.setMenuToken(menuToken);
        }));
      } else {
        return this.refreshTokenSubject.pipe(filter(result => result !== null), take(1));
      }
    }
    isTokenExpired() {
      const token = this.getUserToken();
      if (!token) {
        return true;
      }
      const helper = new JwtHelperService();
      return helper.isTokenExpired(token);
    }
    getUser() {
      const token = this.getUserToken();
      if (!token) {
        return null;
      }
      const helper = new JwtHelperService();
      const d = helper.decodeToken(token);
      return {
        userId: d.uid,
        userCode: d.ucd,
        employeeCode: d.emp,
        fullName: d.fnm,
        defaultRoute: d.drt,
        menus: d.mns,
        siteId: d.sid
      };
    }
    getMenus() {
      const token = this.getMenuToken();
      if (!token) {
        return null;
      }
      const helper = new JwtHelperService();
      const d = helper.decodeToken(token);
      return d.mns;
    }
    isAuth() {
      return !!this.getUser();
    }
    authenticate() {
      return this.dialog.open(AuthenticateComponent, {
        width: '300px',
        height: '256.5px'
      }).afterClosed().toPromise();
    }
    hasMn(mn) {
      const menus = this.getMenus() || [];
      if (Array.isArray(mn)) {
        return menus && mn.some(m => menus.includes(m)) ? true : false;
      }
      return menus && menus.find(m => m === mn) ? true : false;
    }
    logout() {
      this.storageService.clear();
    }
    static ɵfac = function ISessionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ISessionService)(i0.ɵɵinject(i1.MatDialog), i0.ɵɵinject(IStorageService), i0.ɵɵinject(IAuthService));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ISessionService,
      factory: ISessionService.ɵfac
    });
  }
  return ISessionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IWebSocketService = /*#__PURE__*/(() => {
  class IWebSocketService {
    sessionService = inject(ISessionService);
    router = inject(Router);
    http = inject(HttpClient);
    serviceConfiguration = inject(IServiceConfiguration);
    env = this.serviceConfiguration.environment;
    ws;
    wsToken;
    isInitializing;
    isReconnect;
    onOpens = [];
    invokes = {
      '/notification/receive': (data, callId) => {
        // if (document.visibilityState === 'visible') {
        // 	this.snackBar
        // 		.openFromComponent(NotificationComponent, {
        // 			horizontalPosition: 'end',
        // 			verticalPosition: 'bottom',
        // 			duration: 5000,
        // 			data: data
        // 		});
        // }
        // this.notificationService.show(data);
        this.onNotificationReceived.next(data);
        this.callback({}, callId);
      },
      '/notification/read': (data, callId) => {
        this.onNotificationRead.next(data);
        this.callback({}, callId);
      },
      '/auth/logout': (data, callId) => {
        this.onAuthLogout.next(callId);
        this.callback({}, callId);
      }
      // 'get-current-url': (data, callId) => {
      // 	const currentUrl = window.location.href;
      // 	this.callback(currentUrl, callId);
      // },
    };
    onOpen = new ReplaySubject();
    onError = new Subject();
    onClose = new Subject();
    onNotificationReceived = new Subject();
    onNotificationRead = new Subject();
    onAuthLogout = new Subject();
    websocketListener = {};
    websocketQueueListener = {};
    websocketCallback = {};
    websocketEvents = {
      invoke: (url, data, callId) => {
        if (!this.invokes || !this.invokes[url]) {
          return this.callback('invoke method not found', callId);
        }
        return this.invokes[url].call(this, data, callId);
      },
      broadcast: (namespace, url, data, logId, callId) => {
        if (namespace && this.websocketListener[namespace] && this.websocketListener[namespace][url]) {
          this.websocketListener[namespace][url].next({
            data,
            logId,
            callId
          });
        } else {
          // console.log('Listener ' + namespace + ', url ' + url + ' not found');
        }
      },
      callback: (url, data, callId) => {
        const callback = this.websocketCallback[callId];
        if (!callback) {
          return;
        }
        callback.next(data);
        callback.complete();
        this.websocketCallback[callId] = null;
        delete this.websocketCallback[callId];
      },
      close: (url, data, callId) => {
        if (data.reason && data.reason === 'invalid signature') {
          const returnUrl = this.router.url;
          this.sessionService.logout();
          return this.router.navigate(['/auth/login'], {
            queryParams: {
              returnUrl
            }
          });
        }
        return new Promise(null);
      }
    };
    connect() {
      let timeout;
      if (!this.token) {
        if (this.isInitializing) {
          return;
        }
        this.isInitializing = true;
        clearTimeout(timeout);
        let url = this.env.wsUrl.replace('ws', 'http');
        console.log('Initializing');
        return this.http.post(`${url}/init`, JSON.stringify({}), {
          headers: {
            'Content-Type': 'application/json'
          }
        }).pipe(map(result => result.data), catchError(err => this.throwError(err))).toPromise().then(result => {
          this.isInitializing = false;
          this.token = result;
        }).then(() => this.connect());
      }
      if (this.isConnected || this.isConnecting) {
        return;
      }
      this.ws = new WebSocket(this.env.wsUrl + '?id=' + this.uuid() + '&token=' + this.token);
      this.ws.onopen = () => {
        clearTimeout(timeout);
        this.listenQueue();
        this.relisten();
        this.onOpen.next(null);
      };
      this.ws.onerror = error => {
        console.log('Websocket error', error);
        this.onError.next(error);
      };
      this.ws.onclose = reason => {
        console.log('Websocket Disconnected', reason);
        this.onClose.next(reason);
        if (this.isReconnect) {
          this.isReconnect = false;
          return;
        }
        timeout = setTimeout(() => {
          console.log('Reconnecting..');
          this.connect();
        }, 3000);
      };
      this.ws.onmessage = message => {
        const utfData = message.data;
        const jsonData = JSON.parse(utfData);
        const event = jsonData.event;
        if (!event) {
          console.log('Undefined event');
          return;
        }
        const url = jsonData.url;
        const data = jsonData.data;
        const callId = jsonData.callId || 0;
        if (event === 'broadcast') {
          const namespace = jsonData.namespace;
          const logId = jsonData.logId;
          this.websocketEvents[event].call(this.ws, namespace, url, data, logId, callId);
        } else {
          this.websocketEvents[event].call(this.ws, url, data, callId);
        }
      };
    }
    get isConnected() {
      if (!this.ws) {
        return false;
      }
      return this.ws.readyState === WebSocket.OPEN;
    }
    get isConnecting() {
      if (!this.ws) {
        return false;
      }
      return this.ws.readyState === WebSocket.CONNECTING;
    }
    get isClosing() {
      if (!this.ws) {
        return false;
      }
      return this.ws.readyState === WebSocket.CLOSING;
    }
    get isClosed() {
      if (!this.ws) {
        return true;
      }
      return this.ws.readyState === WebSocket.CLOSED;
    }
    get token() {
      return this.wsToken;
    }
    set token(value) {
      this.wsToken = value;
    }
    clearToken() {
      this.wsToken = null;
    }
    reconnect() {
      this.isReconnect = true;
      this.close();
      this.clearToken();
      this.connect();
    }
    uuid() {
      const lut = [];
      for (let i = 0; i < 256; i++) {
        lut[i] = (i < 16 ? '0' : '') + i.toString(16);
      }
      // tslint:disable:no-bitwise
      const d0 = Math.random() * 0xffffffff | 0;
      const d1 = Math.random() * 0xffffffff | 0;
      const d2 = Math.random() * 0xffffffff | 0;
      const d3 = Math.random() * 0xffffffff | 0;
      return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' + lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' + lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] + lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
    }
    send(event, url, data, callId) {
      if (!this.isConnected) {
        console.log('Not connected', event, url, data);
        return of(null);
      }
      const message = {
        event,
        url,
        data: data || {},
        callId
      };
      const callback = new Subject();
      this.websocketCallback[callId] = callback;
      this.ws.send(JSON.stringify(message));
      return callback.asObservable();
    }
    invoke(url, data) {
      const callId = 'cid-' + this.uuid();
      return this.send('invoke', url, data, callId);
    }
    callback(data, callId) {
      return this.send('callback', "", data, callId);
    }
    listenQueue() {
      if (Object.keys(this.websocketQueueListener).length > 0) {
        for (const namespace of Object.keys(this.websocketQueueListener)) {
          for (const url of Object.keys(this.websocketQueueListener[namespace])) {
            this._listen(namespace, url, this.websocketQueueListener[namespace][url]);
          }
        }
      } else {
        // console.log('No queued listener found');
      }
    }
    _listen(namespace, url, subject) {
      const callId = 'cid-' + this.uuid();
      this.send('listen', url, {
        namespace
      }, callId).subscribe(data => {
        if (data.status && data.status === 'success') {
          if (!this.websocketListener[namespace]) {
            this.websocketListener[namespace] = {};
          }
          this.websocketListener[namespace][url] = subject;
        }
      });
    }
    listen(namespace, url) {
      const subject = new Subject();
      if (!this.isConnected) {
        // add to queue
        if (!this.websocketQueueListener[namespace]) {
          this.websocketQueueListener[namespace] = {};
        }
        this.websocketQueueListener[namespace][url] = subject;
      } else {
        // listen
        this._listen(namespace, url, subject);
      }
      return subject;
    }
    unlisten(namespace, url) {
      const callId = 'cid-' + this.uuid();
      this.send('unlisten', url, {
        namespace
      }, callId).subscribe(data => {
        if (data.status && data.status === 'success') {
          if (this.websocketListener[namespace] && this.websocketListener[namespace][url]) {
            this.websocketListener[namespace][url] = {};
            delete this.websocketListener[namespace][url];
          }
        }
      });
    }
    relisten() {
      const callId = 'cid-' + this.uuid();
      if (Object.keys(this.websocketListener).length > 0) {
        for (const namespace of Object.keys(this.websocketListener)) {
          for (const url of Object.keys(this.websocketListener[namespace])) {
            // console.log(`Relistening to namespace '${namespace}', url '${url}'`);
            this.send('listen', url, {
              namespace
            }, callId).subscribe(data => {
              if (data.status && data.status === 'success') {
                // console.log('listeners', this.websocketListener);
              }
            });
          }
        }
      } else {
        // console.log('Not listening to any namespace');
      }
    }
    // clearListener() {
    // 	for (const x of Object.keys(this.listens)) {
    // 		for (const y of Object.keys(this.listens[x])) {
    // 			this.unlisten(x, y);
    // 		}
    // 	}
    // }
    // checkTokenExpiration() {
    // 	return new Observable((observer) => {
    // 		if (!this.sessionService.isAuth() || !this.sessionService.isTokenExpired()) {
    // 			observer.next();
    // 		} else {
    // 			this.sessionService.refreshToken()
    // 				.subscribe(() => {
    // 					observer.next();
    // 				});
    // 		}
    // 	});
    // }
    close() {
      if (this.isConnected) {
        this.ws.close();
      }
    }
    post(path, data = {}) {
      let url = this.env.wsUrl.replace('ws', 'http');
      return this.http.post(`http${url}${path}`, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token
        }
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    get(path, params = new HttpParams()) {
      let url = this.env.wsUrl.replace('ws', 'http');
      return this.http.get(`${url}${path}`, {
        params,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token
        }
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    put(path, body = {}) {
      let url = this.env.wsUrl.replace('ws', 'http');
      // console.log('url', `${url}${path}`);
      return this.http.put(`${url}${path}`, JSON.stringify(body), {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token
        }
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    delete(path) {
      let url = this.env.wsUrl.replace('ws', 'http');
      return this.http.delete(`${url}${path}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token
        }
      }).pipe(map(result => result.data), catchError(err => this.throwError(err)));
    }
    throwError(err) {
      if (err.status === 498) {
        const returnUrl = this.router.url || '';
        return this.router.navigate(['/auth/logout'], {
          queryParams: {
            returnUrl
          }
        });
      } else {
        throw err;
      }
    }
    static ɵfac = function IWebSocketService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IWebSocketService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IWebSocketService,
      factory: IWebSocketService.ɵfac,
      providedIn: 'root'
    });
  }
  return IWebSocketService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let INotificationService = /*#__PURE__*/(() => {
  class INotificationService {
    router = inject(Router);
    webSocketService = inject(IWebSocketService);
    snackBar = inject(MatSnackBar);
    serviceConfiguration = inject(IServiceConfiguration);
    env = this.serviceConfiguration.environment;
    apiUrl = this.env.apiUrl;
    show(data) {
      data.soundSrc = data.soundSrc || this.apiUrl + '/sounds/to-the-point.ogg';
      if (document.visibilityState === 'visible') {
        this.snackBar.openFromComponent(NotificationComponent, {
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
          duration: 5000,
          data
        });
      }
    }
    read() {
      return this.webSocketService.put(`/notification/read`, {
        route: this.router.url
      }).toPromise();
    }
    static ɵfac = function INotificationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || INotificationService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: INotificationService,
      factory: INotificationService.ɵfac,
      providedIn: 'root'
    });
  }
  return INotificationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IUtilityService = /*#__PURE__*/(() => {
  class IUtilityService {
    dialog;
    constructor(dialog) {
      this.dialog = dialog;
    }
    alert(title, description, type) {
      return this.dialog.open(AlertComponent, {
        width: '300px',
        data: {
          title,
          description,
          type
        },
        disableClose: true
      }).afterClosed().toPromise().then(result => {
        return !!result;
      }).catch(err => {
        console.error('alert error', err);
      });
    }
    confirm(title, description, type) {
      return this.dialog.open(ConfirmComponent, {
        width: '300px',
        data: {
          title,
          description,
          type
        },
        disableClose: true
      }).afterClosed().toPromise().then(result => {
        return !!result;
      });
    }
    reason(title, placeholder = 'Reason') {
      return this.dialog.open(ReasonComponent, {
        width: '500px',
        data: {
          title,
          placeholder
        },
        disableClose: true
      }).afterClosed().toPromise().then(result => {
        return result;
      });
    }
    delete(title, description) {
      return this.dialog.open(DeleteComponent, {
        width: '300px',
        data: {
          title,
          description
        },
        disableClose: true
      }).afterClosed().toPromise().then(result => {
        return result;
      });
    }
    singleInputDialog(title, label, placeholder, mask) {
      label = label ?? title;
      placeholder = placeholder ?? title;
      return this.dialog.open(SingleInputDialogComponent, {
        width: '300px',
        data: {
          title,
          label,
          placeholder,
          mask
        }
      }).afterClosed().toPromise();
    }
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    }
    static ɵfac = function IUtilityService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IUtilityService)(i0.ɵɵinject(i1.MatDialog));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IUtilityService,
      factory: IUtilityService.ɵfac,
      providedIn: 'root'
    });
  }
  return IUtilityService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IServiceModule = /*#__PURE__*/(() => {
  class IServiceModule {
    static forRoot(serviceConfiguration) {
      return {
        ngModule: IServiceModule,
        providers: [IApiService, IAuthService, IClipboardService, IColorService, INotificationService, ISessionService, IStorageService, IUtilityService, IWebSocketService, {
          provide: IServiceConfiguration,
          useValue: serviceConfiguration
        }]
      };
    }
    static ɵfac = function IServiceModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IServiceModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: IServiceModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, UiModule, FormsModule, ReactiveFormsModule]
    });
  }
  return IServiceModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of services
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthenticateComponent, IApiService, IAuthService, IClipboardService, IColorService, INotificationService, IServiceConfiguration, IServiceModule, ISessionService, IStorageService, IUtilityService, IWebSocketService, colors };
